import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { AppComponent } from './app.component';
import { ViewpointComponent } from './components/pages/viewpoint/viewpoint.component';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SplashComponent } from '@pages/splash/splash.component';
import { SharedModule } from '@shared/components/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MapComponent } from '@pages/map/map.component';
import { SplitViewComponent } from '@pages/split-view/split-view.component';
import { AngularSplitModule } from 'angular-split';

@NgModule({
  declarations: [
    AppComponent,
    ViewpointComponent,
    SplashComponent,
    MapComponent,
    SplitViewComponent
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    IvyCarouselModule,
    HttpClientModule,
    ModalModule.forRoot(),
    SharedModule,
    AngularSplitModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
